import { createContext } from "react";

export const AccessoryContext = createContext()